import languages, { languageList } from "assets/lang/lang";
export var getFirstUrlParameter = function (url) {
    var value = '';
    if (url) {
        var items = url.match(/[^/]+/g) || [];
        if (items.length) {
            value = items[0];
        }
    }
    return value;
};
export var createLinkBaseOnLang = function (pathname, href) {
    var firstParam = getFirstUrlParameter(pathname);
    var to = '';
    if (languageList.some(function (item) { return item === firstParam; })) {
        to = "/".concat(firstParam) + href;
    }
    else {
        to = href;
    }
    return to;
};
export var changeLang = function (pathname, lang) {
    var firstParam = getFirstUrlParameter(pathname);
    var to = '';
    if (languageList.some(function (item) { return item === firstParam; })) {
        var tmp = pathname.substr(firstParam.length + 1);
        if (tmp !== '/') {
            to = '/' + lang + tmp;
        }
        else {
            to = '/' + lang;
        }
    }
    else {
        if (pathname !== '/') {
            to = '/' + lang + pathname;
        }
        else {
            to = '/' + lang;
        }
    }
    return to;
};
export var makeCanonical = function (domain, pathname) {
    var firstParam = getFirstUrlParameter(pathname);
    if (languageList.some(function (item) { return item === firstParam; })) {
        var lang = languages.find(function (item) { return item.lang === firstParam; });
        if (lang.default) {
            var tmp = pathname.substr(firstParam.length + 1);
            return "".concat(domain).concat(tmp);
        }
    }
    return "".concat(domain).concat(pathname);
};
export var showNavBarItem = function (pathname, itemType) {
    return (pathname.search('mrestate') !== -1 && itemType === 'mrestate') || (pathname.search('mrestate') === -1 && itemType === 'vira');
};
var paths = ['mrestate-info', 'mrestate-intro', 'mrestate-features', 'mrestate-monetization'];
export var removeHeaderFooter = function (location) { return paths.some(function (item) { return location.search(item) !== -1; }); };
export var numberYupRegex = /(^(\d+)$|^([۰۱۲۳۴۵۶۷۸۹]+)$)/;
